import { render, staticRenderFns } from "./MintalMesPrdCraftMaterialConfigEdit.vue?vue&type=template&id=8a776524&"
import script from "./MintalMesPrdCraftMaterialConfigEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdCraftMaterialConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports